import { InjectionToken } from '@angular/core';

export const APP_SERVICE = new InjectionToken('APP_SERVICE');
